import { defineComponent as u, ref as f, computed as x, watch as m, openBlock as o, createBlock as g, Transition as v, withCtx as _, createElementBlock as n, createElementVNode as s, toDisplayString as r, createCommentVNode as l } from "vue";
const h = {
  key: 0,
  class: "w-[348px] will-change-[opacity]",
  role: "alert",
  "aria-live": "polite"
}, b = { class: "gap-size-16 py-padding-48 relative flex flex-col items-center justify-center rounded-sm border border-[var(--popup-border)] bg-[var(--popup-background)] px-[48px] shadow-[0px_2px_6px_0px_rgba(0,0,0,0.1)]" }, y = {
  key: 0,
  class: "text-font-16 tracking-3 m-0 text-center font-semibold leading-5 text-[var(--popup-text)]"
}, k = { class: "gap-size-12 flex flex-col items-center" }, w = { class: "text-font-16 tracking-3 m-0 whitespace-pre-line text-center font-normal leading-5 text-[var(--popup-text)]" }, B = {
  key: 0,
  class: "px-padding-24 py-padding-8 bg-bg-bg-surface w-full rounded-sm"
}, j = { class: "text-font-16 tracking-3 m-0 text-center font-medium leading-5 text-[var(--popup-text)]" }, E = /* @__PURE__ */ u({
  __name: "BaseToast",
  props: {
    title: { default: void 0 },
    message: {},
    details: { default: void 0 },
    show: { type: Boolean, default: !1 }
  },
  setup(a) {
    const e = a, c = f(!1), d = x(() => {
      if (!e.details) return "";
      if (typeof e.details == "string")
        return e.details;
      const t = [];
      return Object.entries(e.details).forEach(([p, i]) => {
        i != null && t.push(`${p}: ${i}`);
      }), t.join(" / ");
    });
    return m(
      () => e.show,
      (t) => {
        c.value = t;
      },
      { immediate: !0 }
    ), (t, p) => (o(), g(v, {
      "enter-active-class": "transition-opacity duration-150 ease-out",
      "leave-active-class": "transition-opacity duration-150 ease-in"
    }, {
      default: _(() => [
        c.value ? (o(), n("div", h, [
          s("div", b, [
            a.title ? (o(), n("h3", y, r(a.title), 1)) : l("", !0),
            s("div", k, [
              s("p", w, r(a.message), 1),
              d.value ? (o(), n("div", B, [
                s("p", j, r(d.value), 1)
              ])) : l("", !0)
            ])
          ])
        ])) : l("", !0)
      ]),
      _: 1
    }));
  }
});
export {
  E as default
};
